import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { NCZIPatientContact } from '../../../Interfaces/ncziPatientInformations';
import ElectronicVaccinationCreateForm from './ElectronicVaccinationCreateForm';
import useTranslation from '../../../../../Hooks/useTranslation';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
}

const ElectronicVaccinationCreateModal: React.FC<Props> = props => {
	const { opened, onClose, patientIdentifier } = props;

	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header title='nczi.vaccination.create.title' firstUpper />
			<Modal.Content>
				<ElectronicVaccinationCreateForm
					onClose={onClose}
					patientIdentifier={patientIdentifier}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicVaccinationCreateModal;
